import {
  background,
  flex,
  margin,
  padding,
  spacing,
  screen,
  gap,
} from '@ebh/capsule/theme';

export default {
  container: [
    flex('row', 'justify-between', 'items-center'),
    background('primary-400'),
    padding(5, 'left'),
    {
      height: '8vh',
      position: 'sticky' as const,
      top: 0,
      width: '100%',
      zIndex: 10,
    },
    screen('md', padding(5, 'x')),
  ],
  hamburgerLogo: [
    margin(5, 'right'),
    { display: 'block', alignItems: 'center', cursor: 'pointer' },
    screen('md', { display: 'none' }),
  ],
  logo: [
    {
      width: spacing(40),
      objectFit: 'contain' as const,
      display: 'block',
      alignItems: 'center',
      cursor: 'pointer',
    },
    padding(2, 'bottom'),
    margin(0, 'left'),
    screen('md', margin(10, 'left')),
  ],
  navData: [
    flex('row', 'center'),
    gap(1),
    margin(4, 'left'),
    margin(0, 'right'),
  ],
  rightPanel: [
    flex('row', 'items-center'),
    margin('auto', 'left'),
    margin(4, 'right'),
  ],
  logout: [
    background('gray-200'),
    margin(2, 'x'),
    {
      width: 2,
      height: '100%',
    },
  ],
  pointer: [
    { cursor: 'pointer' },
    flex('row', 'center'),
    gap(1),
    margin(4, 'right'),
  ],
  displayText: [
    screen('md', {
      display: 'block',
    }),
    { display: 'none' },
  ],
  profileWrapper: [
    {
      position: 'relative' as const,
      alignItems: 'center',
      display: 'none',
    },
    screen('md', {
      display: 'flex',
    }),
  ],
};
